import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'skeleton-strategy-details',
  standalone: false,
  templateUrl: './skeleton-strategy-details.component.html',
  styleUrl: './skeleton-strategy-details.component.scss',
})
export class SkeletonStrategyDetailsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
